import { useState } from 'react'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import ScheduleService from 'services/Schedule'
import AlertDialog from '../AlertDialog'
import GoogleCalendarScheduler from '../GoogleCalendarScheduler'
import MainButton from 'components/Buttons/MainButton'
import SecondaryButton from '../Buttons/SecondaryButton'
import { IoStar } from 'react-icons/io5'
import { DateTime } from 'luxon'

import {
  Container,
  Header,
  Column,
  Row,
  Title,
  SubTitle,
  InfoText,
  StatusText
} from './styles'

export default function CustomerSchedule ({
  data: schedule,
  onEdit: handleEdit,
  onRate: handleRate,
  onDelete: handleDelete,
  showActions = false,
  showCalendarScheduler = true,
  containerStyle = {}
}) {
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const { customer } = schedule
  const scheduleDateTime = DateTime.fromFormat (`${schedule.date} ${schedule.time}`, 'yyyy-MM-dd H:mm')
  const professionalName = schedule.professional.nickname
  const hasBusinessRating = !!schedule.businessRating
  const hasProfessionalRating = !!schedule.professionalRating

  const isCompleted = schedule.validated || (
    DateTime.now () >= scheduleDateTime.plus ({minutes: (schedule.max_delay ?? 0) + 1})
  )

  const cancelSchedule = async () => {
    setDeleting (true)
    try {
      await cutileiApi.delete (`/customers/${customer.id}/schedules/${schedule.id}`)
      setDeleting (false)
      handleDelete (schedule)
    } catch (error) {
      setDeleting (false)
      logApiError (error)
    }
  }

  const renderRatingButton = () => {
    let buttonText = ''
    let navigateTo = ''

    if (schedule.validated && !hasBusinessRating && !hasProfessionalRating) {
      buttonText = 'Avaliar atendimento'
      navigateTo = 'rate_business'
    } else if (schedule.validated && hasBusinessRating && !hasProfessionalRating) {
      buttonText = 'Avaliar profissional'
      navigateTo = 'rate_professional'
    }

    if (!buttonText || !showActions) return null

    return (
      <SecondaryButton
        label={buttonText}
        leftIcon={<IoStar size={18} color='#FFC100' style={{marginBottom: 1}}/>}
        onClick={() => handleRate ({ schedule, navigateTo })}
        width={190}
      />
    )
  }

  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  return (
    <Container scheduleValidated={schedule.validated} style={containerStyle}>
      <Header>
        <Column>
          <SubTitle>
            {scheduleDateTime.setLocale ('pt-BR').toFormat ('cccc')}
          </SubTitle>
          <Title>
            {scheduleDateTime.toFormat ('dd/MM/yyyy')}
          </Title>
        </Column>
        <Title style={{marginTop: 2}}>
          {schedule.time}
        </Title>
      </Header>
      <Row>
        <SubTitle>Salão:</SubTitle>
        <InfoText>{schedule.business.name}</InfoText>
      </Row>
      <Row>
        <SubTitle>Serviço:</SubTitle>
        <InfoText>{schedule.service.name}</InfoText>
      </Row>
      <Row>
        <SubTitle>Profissional:</SubTitle>
        <InfoText>{professionalName}</InfoText>
      </Row>
      <Row>
        <SubTitle>Duração:</SubTitle>
        <InfoText>
          {ScheduleService.getFormattedDuration (
            schedule.duration ?? schedule.service.duration
          )}
        </InfoText>
      </Row>
      <Row>
        <SubTitle>Tolerância:</SubTitle>
        <InfoText>{schedule.max_delay ?? schedule.service.max_delay}m</InfoText>
      </Row>
      {showCalendarScheduler && !isCompleted && (
        <Column>
          <GoogleCalendarScheduler schedules={[schedule]}/>
        </Column>
      )}
      {isCompleted ? (
        <Column>
          <StatusText validated={schedule.validated}>
            {schedule.validated ? 'Realizado': 'Não realizado'}
          </StatusText>
          <Row style={{marginTop: 10}}>
            {renderRatingButton ()}
          </Row>
        </Column>
      ) : showActions && (
        <Column>
          <Row style={{marginTop: 10}}>
            <SecondaryButton
              label='Alterar'
              onClick={() => handleEdit (schedule)}
              width={100}
            />
            {schedule.business.enable_online_cancel && (
              <MainButton
                label='Cancelar'
                onClick={toggleAlertDialog}
                dangerous={true}
                disabled={deleting}
                loading={deleting}
                width={100}
              />
            )}
          </Row>
        </Column>
      )}
      <AlertDialog
        visible={showAlertDialog}
        title='Atenção!'
        message='Deseja realmente cancelar este agendamento?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={cancelSchedule}
        onClose={toggleAlertDialog}
        dangerous={true}
      />
    </Container>
  )
}
